import { render } from "./MdCardMediaCover.vue?vue&type=template&id=32ec8ebd"
import script from "./MdCardMediaCover.vue?vue&type=script&lang=js"
export * from "./MdCardMediaCover.vue?vue&type=script&lang=js"

import "./MdCardMediaCover.vue?vue&type=style&index=0&id=32ec8ebd&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__